import React, { useState } from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import axios from "axios";
import { NETLIFY_API_ROOT } from "../assets/url";
// import { NETLIFY_API_ROOT, LOCAL_ROOT, API_ROOT } from "../assets/url";
import { useSelector, useDispatch } from "react-redux";
import SuccessPayment from "./SuccessPayment";
import styled from "styled-components";
import { clearCart } from "../redux/cartRedux";

const Container = styled.form`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: center;
  max-width: 600px;
  width: 100%;
  min-height: calc(100vh - 60px);
  margin: 0 auto;

  .FormGroup {
    border: none;
  }

  .FormRow {
    padding: 10px;
    border: solid 1px black;
    border-radius: 5px;
  }

  button {
    margin: 10px;
    width: 100px;
    padding: 20px;
    background-color: black;
    border: none;
    border-radius: 10px;
    color: white;
    font-weight: 600;
    font-size: 18px;
    cursor: pointer;
  }
`;

export default function StripeForm() {
  const [success, setSuccess] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const total = useSelector(state => state.cart.total);
  const paymentDesc = `Your total £${total} including shipping`;
  const products = useSelector(state => state.cart.products);
  const dispatch = useDispatch();

  const handleSubmit = async e => {
    e.preventDefault();

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });

    if (!error) {
      try {
        const { id } = paymentMethod;

        // creating payment in Stripe
        const res = await axios.post(`${NETLIFY_API_ROOT}/api/payment`, {
          amount: total * 100,
          description: paymentDesc,
          id,
        });

        if (res.data.success) {
          // create order in DB
          const order = await axios.post(`${NETLIFY_API_ROOT}/api/orders`, {
            userId: "test user",
            products: products.map(product => product),
            amount: total,
            address: "test address",
          });

          // emptying cart after successful pament & order creation
          dispatch(clearCart());

          console.log("Successful Payment");
          console.log(order.data);
          setSuccess(true);
        }
      } catch (error) {
        throw error;
      }
    } else {
      console.log(error);
    }
  };

  return (
    <>
      {!success ? (
        <Container onSubmit={handleSubmit}>
          <fieldset className="FormGroup">
            <div className="FormRow">
              <CardElement
              // options={CARD_OPTIONS}
              />
            </div>
          </fieldset>
          <button>Pay</button>
        </Container>
      ) : (
        <SuccessPayment />
      )}
    </>
  );
}
